import type { ReferencedBrandScrapeResponse } from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export const triggerReferencedBrandsScrape = async (): Promise<ReferencedBrandScrapeResponse> => {
  const { data } = await gozokiApiWithAuth.post<ReferencedBrandScrapeResponse>(
    '/referenced-brands/scrape',
  )
  return data
}
